var _path, _rect, _rect2, _rect3, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30_\u9884\u68C0\u5206\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.15,8A5.85,5.85,0,0,1,58,13.81h0v28.6a5.85,5.85,0,0,1-5.85,5.85H11.85A5.85,5.85,0,0,1,6,42.41H6V13.81A5.85,5.85,0,0,1,11.85,8Zm0,3.9H11.85a2,2,0,0,0-1.95,2h0v28.6a2,2,0,0,0,1.95,2h40.3a2,2,0,0,0,2-2V13.81A2,2,0,0,0,52.15,11.86ZM17,34.64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.99,
    y: 52.11,
    width: 32,
    height: 4,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.03,
    y: 20.01,
    width: 27.87,
    height: 4,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31.98,
    width: 16,
    height: 4,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.38,27.56A2,2,0,0,0,46,27a2,2,0,0,0-1.41.58l-4.62,4.62-1.41-1.4a2,2,0,0,0-1.41-.58,2,2,0,0,0-1.42,3.41l2.74,2.73.08.1a2,2,0,0,0,1.41.58h0a2,2,0,0,0,1.41-.58l.08-.1,6-6A2,2,0,0,0,47.38,27.56Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriage);
export default __webpack_public_path__ + "static/media/triage.d14d7718.svg";
export { ForwardRef as ReactComponent };